import React from 'react';
import { Switch as AntdSwitch } from 'antd';
import './style.scss';

export const Switch = ({ onChange, checked, ...props }) => {
  return <AntdSwitch onChange={onChange} checked={checked} {...props} />;
};
